import * as SearchField from './types/search-fields-map'
import { SearchFieldMapGroup } from './types/search-fields-map.types'

export const carSearchFields: SearchFieldMapGroup = {
    postcode: SearchField.postcode,
    distance: SearchField.distance,
    make: SearchField.make,
    model: SearchField.model,
    modelVariant: SearchField.modelVariant,
    minPrice: SearchField.minPrice,
    maxPrice: SearchField.maxPrice,
    minMonthlyPrice: SearchField.minMonthlyPrice,
    maxMonthlyPrice: SearchField.maxMonthlyPrice,
    minYear: SearchField.minYear,
    maxYear: SearchField.maxYear,
    dealsOnly: SearchField.dealsOnly,
    mileage: SearchField.mileage,
    transmission: SearchField.transmission,
    fuelType: SearchField.fuelType,
    batteryRangeValues: SearchField.batteryRangeValues,
    batteryChargeTimeValues: SearchField.batteryChargeTimeValues,
    batteryQuickChargeTimeValues: SearchField.batteryQuickChargeTimeValues,
    bodyType: SearchField.bodyType,
    minEngineSize: SearchField.minEngineSize,
    maxEngineSize: SearchField.maxEngineSize,
    sellerType: SearchField.sellerType,
    doors: SearchField.doors,
    colour: SearchField.colour,
    minSeats: SearchField.minSeats,
    maxSeats: SearchField.maxSeats,
    acceleration: SearchField.acceleration,
    annualTax: SearchField.annualTax,
    drivetrain: SearchField.drivetrain,
    fuelConsumption: SearchField.fuelConsumption,
    insurance: SearchField.insurance,
    carbonEmissions: SearchField.carbonEmissions,
    writeOffCategory: SearchField.writeOffCategory,
    keywords: SearchField.keywords,
    northernIreland: SearchField.northernIreland,
    manufacturerApproved: SearchField.manufacturerApproved,
    additionalAds: SearchField.additionalAds,
    partExchangeAvailable: SearchField.partExchangeAvailable,
    minBHP: SearchField.minBHP,
    maxBHP: SearchField.maxBHP,
}

export const vansSearchFields: SearchFieldMapGroup = {
    postcode: SearchField.postcode,
    distance: SearchField.distance,
    make: SearchField.make,
    model: SearchField.model,
    bodyType: SearchField.bodyType,
    minSuppliedPrice: SearchField.minSuppliedPrice,
    maxSuppliedPrice: SearchField.maxSuppliedPrice,
    minMonthlyPrice: SearchField.minMonthlyPrice,
    maxMonthlyPrice: SearchField.maxMonthlyPrice,
    minYear: SearchField.minYear,
    maxYear: SearchField.maxYear,
    mileage: SearchField.mileage,
    minEngineSize: SearchField.minEngineSize,
    maxEngineSize: SearchField.maxEngineSize,
    wheelbase: SearchField.wheelbase,
    transmission: SearchField.transmission,
    minSeats: SearchField.minSeats,
    maxSeats: SearchField.maxSeats,
    colour: SearchField.colour,
    doors: SearchField.doors,
    fuelType: SearchField.fuelType,
    fuelConsumption: SearchField.fuelConsumption,
    carbonEmissions: SearchField.carbonEmissions,
    cabType: SearchField.cabType,
    sellerType: SearchField.sellerType,
    keywords: SearchField.keywords,
    writeOffCategory: SearchField.writeOffCategory,
    minBHP: SearchField.minBHP,
    maxBHP: SearchField.maxBHP,
    manufacturerApproved: SearchField.manufacturerApproved,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const bikesSearchFields: SearchFieldMapGroup = {
    postcode: SearchField.postcode,
    distance: SearchField.distance,
    make: SearchField.make,
    model: SearchField.model,
    minPrice: SearchField.minPrice,
    maxPrice: SearchField.maxPrice,
    minMonthlyPrice: SearchField.minMonthlyPrice,
    maxMonthlyPrice: SearchField.maxMonthlyPrice,
    minYear: SearchField.minYear,
    maxYear: SearchField.maxYear,
    dealsOnly: SearchField.dealsOnly,
    mileage: SearchField.mileage,
    fuelType: SearchField.fuelType,
    bodyType: SearchField.bodyType,
    minCC: SearchField.minCC,
    maxCC: SearchField.maxCC,
    sellerType: SearchField.sellerType,
    colour: SearchField.colour,
    keywords: SearchField.keywords,
    partExchangeAvailable: SearchField.partExchangeAvailable,
    manufacturerApproved: SearchField.manufacturerApproved,
    writeOffCategory: SearchField.writeOffCategory,
}

export const motorhomesSearchFields: SearchFieldMapGroup = {
    postcode: SearchField.postcode,
    distance: SearchField.distance,
    make: SearchField.make,
    model: SearchField.model,
    minPrice: SearchField.minPrice,
    maxPrice: SearchField.maxPrice,
    minYear: SearchField.minYear,
    maxYear: SearchField.maxYear,
    mileage: SearchField.mileage,
    fuelType: SearchField.fuelType,
    bodyType: SearchField.bodyType,
    keywords: SearchField.keywords,
    bedroomLayout: SearchField.bedroomLayout,
    berth: SearchField.berth,
    transmission: SearchField.transmission,
    minSeats: SearchField.minSeats,
    maxSeats: SearchField.maxSeats,
    minLength: SearchField.minLength,
    maxLength: SearchField.maxLength,
    endLayout: SearchField.endLayout,
    sellerType: SearchField.sellerType,
    sellerDefinedUsed: SearchField.sellerDefinedUsed,
    writeOffCategory: SearchField.writeOffCategory,
    driverPosition: SearchField.driverPosition,
    minEngineSize: SearchField.minEngineSize,
    maxEngineSize: SearchField.maxEngineSize,
}

export const caravansSearchFields: SearchFieldMapGroup = {
    postcode: SearchField.postcode,
    distance: SearchField.distance,
    make: SearchField.make,
    model: SearchField.model,
    minPrice: SearchField.minPrice,
    maxPrice: SearchField.maxPrice,
    minYear: SearchField.minYear,
    maxYear: SearchField.maxYear,
    style: SearchField.style,
    berth: SearchField.berth,
    minLength: SearchField.minLength,
    maxLength: SearchField.maxLength,
    endLayout: SearchField.endLayout,
    sellerType: SearchField.sellerType,
    sellerDefinedUsed: SearchField.sellerDefinedUsed,
    keywords: SearchField.keywords,
    bedroomLayout: SearchField.bedroomLayout,
    minMTPLM: SearchField.minMTPLM,
    maxMTPLM: SearchField.maxMTPLM,
    trailerAxle: SearchField.trailerAxle,
}
